import * as React from 'react';
import moment from 'moment';

import withStyles, {
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core/styles/withStyles';

import {
  Paper,
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Typography,
  Divider,
  Button
} from '@material-ui/core';

import RequestedIcon from '@material-ui/icons/Schedule';
import StartedIcon from '@material-ui/icons/Timelapse';
import FinishedIcon from '@material-ui/icons/CloudDone';

import { withRouter, RouteComponentProps } from 'react-router-dom';

import { NotificationsProvider } from '../providers';
import SidePanel from './SidePanel';

type Props = WithStyles & RouteComponentProps<any>;

const styles: StyleRulesCallback = theme => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    height: '100vh'
  },
  list: {
    marginBottom: 30
  },
  statusCell: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  progress: {
    width: '100%'
  },
  button: {
    marginTop: theme.spacing.unit * 2
  },
  content: {
    padding: theme.spacing.unit * 3,
    flex: 1,
    overflowY: 'scroll',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'center'
  }
});

function compareTime(a: Notification, b: Notification): number {
  return parseInt(b.modifiedOn, 10) - parseInt(a.modifiedOn, 10);
}

function formatTimestamp(
  timestampRaw: string,
  format: string = 'DD/MM hh:mm:ss'
) {
  return moment(parseInt(timestampRaw, 10)).format(format);
}

function getProcessingStatusIcon(status: string) {
  switch (status) {
    case 'requested':
      return (
        <>
          <RequestedIcon style={{ color: '#aaa' }} />
          &nbsp;
          <span>en espera</span>
        </>
      );
    case 'started':
      return (
        <>
          <StartedIcon style={{ color: 'orange' }} />
          &nbsp;
          <span>en proceso</span>
        </>
      );
    case 'finished':
      return (
        <>
          <FinishedIcon style={{ color: 'green' }} />
          &nbsp;
          <span>finalizado</span>
        </>
      );
    default:
      return null;
  }
}

function getSceneProcessingMessage(values: string[]) {
  const [format, capturedOn, fieldName] = values;
  return `procesando escena ${format} del ${formatTimestamp(
    capturedOn,
    'DD/MM/YYYY'
  )} para el lote ${fieldName}`;
}

function getStats(notifications: Notification[]) {
  let requested = 0,
    started = 0,
    finished = 0;
  notifications.forEach(n => {
    requested += n.lastStatus === 'requested' ? 1 : 0;
    started += n.lastStatus === 'started' ? 1 : 0;
    finished += n.lastStatus === 'finished' ? 1 : 0;
  });
  return [requested, started, finished];
}

class Notifications extends React.Component<Props> {
  renderNotificationRow(n: Notification) {
    const { classes } = this.props;
    return (
      <TableRow>
        <TableCell>{formatTimestamp(n.modifiedOn)}</TableCell>
        <TableCell>
          <div className={classes.statusCell}>
            {getProcessingStatusIcon(n.lastStatus)}
          </div>
        </TableCell>
        <TableCell>{getSceneProcessingMessage(n.values)}</TableCell>
      </TableRow>
    );
  }

  renderProcessingTable(notifications: Notification[]) {
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Hora</TableCell>
            <TableCell>Estado</TableCell>
            <TableCell>Asunto</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {notifications
            .slice()
            .sort(compareTime)
            .map(n => this.renderNotificationRow(n))}
        </TableBody>
      </Table>
    );
  }

  renderProgress(notifications: Notification[]) {
    const { classes } = this.props;
    const [requested, started, finished] = getStats(notifications);
    const total = requested + started + finished;
    return (
      <LinearProgress
        className={classes.progress}
        color="secondary"
        variant="buffer"
        value={(100 * finished) / total}
        valueBuffer={(100 * (finished + started)) / total}
      />
    );
  }

  renderPanel() {
    const { classes } = this.props;
    return (
      <>
        <Typography variant="headline">Mis Notificaciones</Typography>
        <List component="nav" className={classes.list}>
          <ListItem>
            <ListItemText primary="Procesamiento de Escenas" />
            <ListItemSecondaryAction>
              <Switch checked={true} />
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText primary="Seguimiento Automatico" />
            <ListItemSecondaryAction>
              <Switch checked={true} />
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText primary="Anomalias" />
            <ListItemSecondaryAction>
              <Switch checked={true} />
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <Button fullWidth={true} variant="raised" className={classes.button}>
            Limpiar Notificaciones
          </Button>
        </List>
      </>
    );
  }

  render() {
    const { classes } = this.props;
    return (
      <NotificationsProvider pollInterval={5 * 1000}>
        {renders => (
          <main className={classes.root}>
            <SidePanel>{this.renderPanel()}</SidePanel>
            <Paper square={true} elevation={1} className={classes.content}>
              {renders.notifications && (
                <>
                  {this.renderProgress(renders.notifications)}
                  {this.renderProcessingTable(renders.notifications)}
                </>
              )}
            </Paper>
          </main>
        )}
      </NotificationsProvider>
    );
  }
}

export default withStyles(styles)(withRouter(Notifications));



// WEBPACK FOOTER //
// ./src/containers/Notifications.tsx